import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Soft-deletes a show. A program that still has episodes is refused (see `errors`).
const POST_DELETE_RADIO_SHOW = gql`
  mutation postDeleteRadioShow($id: Int!) {
    postDeleteRadioShow(id: $id) {
      isAuth
      ok
      errors { field message }
    }
  }
`;

const postDeleteRadioShow = async ({ id }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_DELETE_RADIO_SHOW,
        variables: { id },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postDeleteRadioShow: postDeleteRadioShowData },
    } = result;

    if (postDeleteRadioShowData) {
      return postDeleteRadioShowData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteRadioShow = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteRadioShow Error: ${error}`);
    return null;
  }
};

export default postDeleteRadioShow;
